import './vendor.ts';

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { Ng2Webstorage } from 'ng2-webstorage';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';

import { DeviceConfigurerServiceSharedModule, UserRouteAccessService } from './shared';
import { DeviceConfigurerServiceHomeModule } from './home/home.module';
import { DeviceConfigurerServiceAdminModule } from './admin/admin.module';
import { DeviceConfigurerServiceAccountModule } from './account/account.module';
import { DeviceConfigurerServiceEntityModule } from './entities/entity.module';

import { LayoutRoutingModule } from './layouts';
import { customHttpProvider } from './blocks/interceptor/http.provider';
import { PaginationConfig } from './blocks/config/uib-pagination.config';

import {
    DcsMainComponent,
    NavbarComponent,
    FooterComponent,
    ProfileService,
    PageRibbonComponent,
    ActiveMenuDirective,
    ErrorComponent
} from './layouts';
import { DashboardModule } from './dashboard/dashboard.module';
//import {DndModule} from 'ng2-dnd/ng2-dnd';


@NgModule( {
    imports: [
        BrowserModule,
        LayoutRoutingModule,
        Ng2Webstorage.forRoot( { prefix: 'jhi', separator: '-' } ),
        DeviceConfigurerServiceSharedModule,
        DeviceConfigurerServiceHomeModule,
        DeviceConfigurerServiceAdminModule,
        DeviceConfigurerServiceAccountModule,
        DeviceConfigurerServiceEntityModule,
        DashboardModule,
        ProgressbarModule.forRoot(),

    ],
    declarations: [
        DcsMainComponent,
        NavbarComponent,
        ErrorComponent,
        PageRibbonComponent,
        ActiveMenuDirective,
        FooterComponent
    ],
    providers: [
        ProfileService,
        { provide: Window, useValue: window },
        { provide: Document, useValue: document },
        customHttpProvider(),
        PaginationConfig,
        UserRouteAccessService
    ],
    bootstrap: [ DcsMainComponent ]
} )
export class DeviceConfigurerServiceAppModule {
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/app.module.ts